var map = {
	"./Nastavení.svg": "afc3",
	"./billings.svg": "5356",
	"./client-evaluation.svg": "cb84",
	"./clients-evaluations.svg": "8e34",
	"./closings.svg": "28bb",
	"./cloud.svg": "f2de",
	"./dashboard.svg": "81ba",
	"./files.svg": "4994",
	"./logout.svg": "67fa",
	"./new-work-tasks.svg": "667c",
	"./parties.svg": "f42a",
	"./projects.svg": "f30c",
	"./reports.svg": "e5b9",
	"./resources.svg": "091c",
	"./settings.svg": "aa47",
	"./statements.svg": "2a8c",
	"./tasks.svg": "e9ac",
	"./visit-rules.svg": "9309",
	"./work-task-rules.svg": "2690",
	"./work-tasks.svg": "7e0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef65";